import type { BudgetSection } from "../../../types";
import SectionCard from "./SectionCard";

interface Props {
  sections: BudgetSection[];
  activeSection: BudgetSection | null;
  onSectionClick: (section: BudgetSection) => void;
  hidePlanned?: boolean;
}

export default function SectionCards({ sections, activeSection, onSectionClick, hidePlanned = false }: Props) {
  return (
    <div className="grid grid-cols-3 gap-4">
      {sections.map((section) => (
        <SectionCard
          key={section.id}
          section={section}
          isActive={activeSection?.id === section.id}
          onClick={onSectionClick}
          hidePlanned={hidePlanned}
        />
      ))}
    </div>
  );
}
